module.exports = __webpack_public_path__ + "static/media/tie-fighers-and-star-destroyer.246c3d84.jpg";